// extracted by mini-css-extract-plugin
module.exports = {"sectionColumn":"SectionColumn_sectionColumn__tM9ZA","title":"SectionColumn_title__DxlAl"};